import { render, staticRenderFns } from "./chartDemandaAtivaV2.vue?vue&type=template&id=7d1b8a64&"
import script from "./chartDemandaAtivaV2.vue?vue&type=script&lang=js&"
export * from "./chartDemandaAtivaV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports